module.exports = __webpack_public_path__ + "static/media/KE.3fee9f0a.svg";